import { render, staticRenderFns } from "./UserMeta.vue?vue&type=template&id=16e0939f&scoped=true&"
import script from "./UserMeta.vue?vue&type=script&lang=js&"
export * from "./UserMeta.vue?vue&type=script&lang=js&"
import style0 from "@/sass/08_modules/user-meta.scss?vue&type=style&index=0&id=16e0939f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16e0939f",
  null
  
)

export default component.exports